(function () {
  'use strict';

  // Taken from implementation of ng-tag-input, which was copied from stackoverflow
  angular.module('ringbaPortal').directive('inputAutoresize', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {
        const threshold = 20;
        const elementInitialWidth = element.prop('offsetWidth');

        const span = angular.element('<span class="input"></span>');
        span.css('display', 'none')
          .css('visibility', 'hidden')
          .css('width', 'auto')
          .css('white-space', 'pre');

        element.parent().append(span);

        const resize = function(originalValue) {
          let value = originalValue, width;

          if (angular.isString(value) && value.length === 0) {
            value = attrs.placeholder;
          }

          if (value) {
            span.text(value);
            span.css('display', '');
            width = span.prop('offsetWidth');
            span.css('display', 'none');
          }

          // Always set the minimum width to be the initial width
          if (width < elementInitialWidth) {
            width = elementInitialWidth;
          }
          element.css('width', width ? width + threshold + 'px' : '');

          return originalValue;
        };

        ctrl.$parsers.unshift(resize);
        ctrl.$formatters.unshift(resize);
      }
    };
  });
})();
